import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_926lzrw9gt: FaireBrandEntity = {
  token: "b_926lzrw9gt",
  type: "brand",
  name: "Hana",
  avatarUrl:
    "https://cdn.faire.com/fastly/cdae755cbce9fb74f54b5e571b751fa9069fccccb6b4c89c78b2886264bdb823.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/12829e1af4f3a0760811f1fd2d49ebbfc3dde74cc452692fc7249e40d2405756.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cdae755cbce9fb74f54b5e571b751fa9069fccccb6b4c89c78b2886264bdb823.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/12829e1af4f3a0760811f1fd2d49ebbfc3dde74cc452692fc7249e40d2405756.jpeg",
  location: "Elkridge, MD, USA",
  minimumOrderDollars: 75,
  rating: 4.9,
  reviewCount: 1602,
  isTopShop: true,
  isInsider: true,
  description:
    "Hana Wholesale founded in 1998. A leader in the wholesale fashion industry, we strive to produce only the highest quality product and the most professional customer service. Catering to our market needs, we have a strong presence our E-Commerce platforms to be able to reach customers through the web.\n\nHana Wholesale is always innovating, always planning and always thinking ahead. We are so thankful for all those who have been a part of journey until now, and so excited for those who will be joining us in the near future. Why waste anymore time? Go ahead and register with us and see what everyone has been talking about and see what you have been missing out on! Every shop and boutique deserves a little bit of Hana Wholesale.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:00.754Z",
    importedBy: "entity-db-cli",
  },
};
